import type { FunctionComponent } from 'react';
import { Text } from '@kanda-libs/ks-design-library';
import { Field, FormTheme } from '@kanda-libs/ks-component-ts';

import useCalculator from './useCalculator';
import { CLASS_NAMES, CREDIT_AMOUNT_FIELD_NAME } from './constants';

const Calculator: FunctionComponent = function () {
  const {
    isLoading,
    maxCredit,
    minDeposit,
    quotePrice,
    depositAmount,
    creditAmountValidation,
    onBlur,
  } = useCalculator();

  return (
    <div className={CLASS_NAMES.wrapper}>
      <Text
        isLoading={isLoading}
        text="Calculator"
        className={CLASS_NAMES.heading}
      />
      <Text
        isLoading={isLoading}
        text="Choose how much of the loan amount to use for the quote."
        className={CLASS_NAMES.subHeading}
      />
      <div className={CLASS_NAMES.card}>
        <div className={CLASS_NAMES.container}>
          <div className={CLASS_NAMES.box}>
            <Text
              isLoading={isLoading}
              text="Loan"
              className={CLASS_NAMES.lineHeading}
            />
            <Text
              isLoading={isLoading}
              text={`Max. ${maxCredit} loan amount available.`}
              className={CLASS_NAMES.lineSubheading}
            />
          </div>
          <div className={CLASS_NAMES.box}>
            <FormTheme variant="streamline">
              <Field.Validator validation={creditAmountValidation}>
                <Field.NumberInput
                  name={CREDIT_AMOUNT_FIELD_NAME}
                  placeholder="£0.00"
                  type="price"
                  onBlur={onBlur}
                />
              </Field.Validator>
            </FormTheme>
          </div>
        </div>
        <div className={CLASS_NAMES.container}>
          <div className={CLASS_NAMES.box}>
            <Text
              isLoading={isLoading}
              text="Cash Deposit"
              className={CLASS_NAMES.lineHeading}
            />
            <Text
              isLoading={isLoading}
              text={`Minimum cash deposit required by tradesperson is ${minDeposit}`}
              className={CLASS_NAMES.lineSubheading}
            />
          </div>
          <div className={CLASS_NAMES.box}>
            <Text
              isLoading={isLoading}
              text={depositAmount}
              className={CLASS_NAMES.lineTotal}
            />
          </div>
        </div>
        <div className={CLASS_NAMES.separator} />
        <div className={CLASS_NAMES.container}>
          <div className={CLASS_NAMES.box}>
            <Text
              isLoading={isLoading}
              text="Quote Price"
              className={CLASS_NAMES.lineHeading}
            />
            <Text
              isLoading={isLoading}
              text="The total price of the quote"
              className={CLASS_NAMES.lineSubheading}
            />
          </div>
          <div className={CLASS_NAMES.box}>
            <Text
              isLoading={isLoading}
              text={quotePrice}
              className={CLASS_NAMES.lineTotal}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

Calculator.displayName = 'Calculator-view';

export default Calculator;
